export const sidenote_source__type: Record<string, string> = {
  0: "Book",
  1: "Website",
  2: "Article",
  3: "",
}
